import { useEffect } from 'react';

const HOSTS = ['.fondo', '.skill', '.experience', '.project', '.apps', '.contact'];

const DIRS = [
  'top',
  'bottom',
  'left',
  'right',
  'diag-up-left',
  'diag-down-right',
  'flipX',
  'flipY',
];

function useCubeReveal() {
  useEffect(() => {
    const hosts = HOSTS.map((sel) => document.querySelector(sel)).filter(Boolean);
    if (!hosts.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      hosts.forEach((h) => h.classList.add('cube-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) {
            const dir = DIRS[Math.floor(Math.random() * DIRS.length)];
            el.classList.remove('cube-visible');
            el.dataset.cube = dir;
            void el.offsetWidth;
            el.classList.add('cube-visible');
          } else {
            el.classList.remove('cube-visible');
            // Limpiar la pose oculta (data-cube) al salir: si queda puesta su
            // transform (p.ej. translateY(35%) en una seccion de 4400px)
            // corre el rect del elemento y la re-deteccion de entrada queda
            // disparando miles de px tarde (seccion invisible al volver).
            delete el.dataset.cube;
          }
        });
      },
      // Dispara ANTES de que la seccion entre al viewport (lead de 40% del
      // alto del viewport) para que no se vea una zona vacia al hacer scroll.
      { threshold: 0, rootMargin: '0px 0px 40% 0px' }
    );

    hosts.forEach((h) => observer.observe(h));
    return () => observer.disconnect();
  }, []);
}

export default useCubeReveal;
